<div>
  <iframe *ngIf="safePdfUrl" [src]="safePdfUrl" style="width:100%; height:1000px;"></iframe>
</div>
